import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@/lib/utils';
import * as ToastPrimitive from '@radix-ui/react-toast';
/**
 * Toast component to display brief/timed messages to users.
 * @param children - Should contain both the trigger cta of the Toast and the ToastRoot
 * @param viewportClassName - Class name for the Toast viewport container, positions the toast on the screen
 */
function Toast({ children, viewportClassName, ...props }) {
    return (_jsxs(ToastPrimitive.Provider, { ...props, children: [children, _jsx(ToastPrimitive.Viewport, { className: cn('fixed bottom-0 left-0 z-50 w-full p-4 md:w-fit', viewportClassName) })] }));
}
function ToastRoot({ children, ...props }) {
    return (_jsx(ToastPrimitive.Root, { "data-slot": "toast-root", ...props, children: children }));
}
function ToastTitle({ ...props }) {
    return _jsx(ToastPrimitive.Title, { "data-slot": "toast-title", ...props });
}
function ToastDescription({ ...props }) {
    return _jsx(ToastPrimitive.Description, { "data-slot": "toast-description", ...props });
}
function ToastAction({ ...props }) {
    return _jsx(ToastPrimitive.Action, { "data-slot": "toast-action", ...props });
}
function ToastClose({ ...props }) {
    return _jsx(ToastPrimitive.Close, { "data-slot": "toast-close", ...props });
}
export { Toast, ToastAction, ToastClose, ToastDescription, ToastRoot, ToastTitle };
